module.exports = __webpack_public_path__ + "img/motor.4903bc85.png";